import { Configuration } from 'fi-ui-common'
import { View } from './workspace-management.state'
import { GridsterApi } from 'angular-gridster2'

export class GetApplicationConfigurations {
  static readonly type = '[WorkspaceManagement] Get Application Configurations'
}

export class ToggleSidebar {
  static readonly type = '[WorkspaceManagement] Toggle Sidebar'

  constructor(public isSidebarCollapsed: boolean) { }
}

export class CreateLayout {
  static readonly type = '[WorkspaceManagement] Create a Layout'

  constructor(public label: string, public views?: View[]) { }
}

export class SetSelectedLayout {
  static readonly type = '[WorkspaceManagement] Set Selected Layout'

  constructor(public selectedLayout: Configuration | null) { }
}

export class FetchConfigurations {
  static readonly type = '[WorkspaceManagement] Fetch Configurations'
}

export class FetchViews {
  static readonly type = '[WorkspaceManagement] Fetch Views'
}

export class ToggleViewSelection {
  static readonly type = '[WorkspaceManagement] Set View Visibility'

  constructor(public payload: View) { }
}
export class SaveLayout {
  static readonly type = '[WorkspaceManagement] Save Layout';
  constructor( public type: 'auto' | 'manual', public displayToast?: boolean,) { }
}

export class RemoveView {
  static readonly type = '[WorkspaceManagement] Remove View'

  constructor(public label: string) { }
}

export class AddView {
  static readonly type = '[WorkspaceManagement] Add View'

  constructor(public view: View) { }
}

export class SetState {
  static readonly type = '[WorkspaceManagement] Set State'

  constructor(public payload: any) { }
}

export class UpdateSecondariesSettings {
  static readonly type = '[WorkspaceManagement] Update Secondaries Settings';
  constructor(public settings: { bondOrder?: Record<string, string[]>; isCustomSortEnabled?: boolean }) { }
}

export class ResetLayoutChanges {
  static readonly type = '[WorkspaceManagement] Reset Layout Changes'
}

export class UpdateAutosaveSettings {
  static readonly type = '[WorkspaceManagement] Update Autosave Settings'
  constructor(public settings: { isColumnAutosaveEnabled?: boolean; isViewAutosaveEnabled?: boolean }) { }
}

export class SetGridsterAPI {
  static readonly type = '[WorkspaceManagement] Set Gridster API'
  constructor(public gridsterAPI: GridsterApi) { }
}

export class ResizeGridster {
  static readonly type = '[WorkspaceManagement] Resize Gridster'
}
